<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-select style="width: 200px" v-model="channel" allowClear @change="init_table_data"
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option v-if="channelItem.status==1"
                           :key="channelItem.channel"
                           :value="channelItem.channel"
                           :label="channelItem.name"
                           v-for="channelItem in channelList">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-date-picker
          @change="init_table_data"
          style="width: 200px;"
          v-model="date"
          valueFormat="YYYY-MM" />
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" @click="addData()">新增数据</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.id" :loading="tableLoad"
             bordered :pagination="false">
      <template slot="revenue" slot-scope="text,recode">
        <a-input v-if="recode.id==editId" v-model="recode.revenue"></a-input>
        <div v-else>{{text}}</div>
      </template>
      <template slot="action" slot-scope="text,recode">
        <a-button v-if="editId!=recode.id" type="danger" size="small" @click="deleteInfo(recode.id)">删除</a-button>
        <a-button v-else type="primary" size="small" @click="doEditInfo(recode)">保存</a-button>
        <a-button v-if="editId!=recode.id" type="info" size="small" @click="editInfo(recode.id)">编辑</a-button>
        <a-button v-else type="danger" ghost size="small" @click="()=>{editId=0}">取消</a-button>
      </template>
    </a-table>
    <AddPanel :show-panel="addShow" :channel-list="channelList" @close-dialog="closeAdd"></AddPanel>
  </div>
</template>

<script>
import AddPanel from "./AddPanel";
import {DeleteRevenueSelf, EditRevenueSelf, GetRevenueSelf} from "../../../api/v1/revenue_self_api";
export default {
  name: "Index",
  components: {AddPanel},
  data(){
    return {
      channelList:[],
      channel:[],
      date:'',
      tableLoad:false,
      tableData:[],
      channelShow:false,
      addShow:false,
      editId:0,
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        { title: '日期', dataIndex: 'date',align:'center'},
        { title: '渠道', dataIndex: 'channel',align:'center'},
        { title: '收益', dataIndex: 'revenue', scopedSlots: { customRender: 'revenue' },align:'center'},
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' },width:'200px',align:'center'},
      ]
      return _table_columns
    },
    getAppId(){
      return this.$store.getters.getAppId
    },
  },
  watch:{
    getAppId:{
      handler(newName, oldName) {
        this.init_table_data()
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.init_table_data()
  },
  methods:{
    init_table_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetRevenueSelf({
        channel:this.channel,
        date:this.date,
        app_id:this.getAppId
      }).then(resp => {
        this.tableLoad = false
        if (resp.code==200){
          this.tableData = resp.data.list
          this.date = resp.data.date
        }
      })
    },
    editInfo(id){
      this.editId = id
    },
    doEditInfo(recode){
      EditRevenueSelf({
        id:recode.id,
        revenue:recode.revenue
      }).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.editId = 0
          this.init_table_data()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    deleteInfo(id){
      DeleteRevenueSelf({id:id}).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.init_table_data()
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    openChannel(){
      this.channelShow = true
    },
    closeChanel(){
      this.channelShow = false
    },
    closeAdd(){
      this.addShow = false
      this.init_table_data()
    },
    addData(){
      this.addShow = true
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Self/Index.vue